import * as moment from 'moment/moment';

export class PusherConversationVM {
  id?: number;
  name?: string;
  accountName?: string;
  email?: string;
  phone?: any[];
  status?: string;
  unreadMessageCount?: number;
  createDate?: string;
  lastMessage?: {
    text: string;
    type: string;
    status: string;
  };
  subscribed?: boolean;
  expired?: boolean;

  static toVM(conversation: PusherConversation) {
    const lastMessage = conversation?.LastMessage;
    const subscribed = conversation?.Subscribed;

    return {
      id: conversation?.Group?.Id ?? '',
      name: conversation?.ExternalMember?.ContactName ?? 'Unknown',
      accountId: conversation?.ExternalMember?.AccountId ?? '',
      accountName: conversation?.ExternalMember?.AccountName ?? 'Unknown',
      image: '',
      phone: [{ phone: conversation?.ExternalMember?.PhoneNumber ?? '' }],
      internalPhoneNoId: conversation?.Group?.InternalPhoneNoId ?? '',
      status: conversation?.Group?.IsActive ? 'Active' : 'Pending',
      createDate: conversation?.Group?.CreatedDate ?? '',
      unreadMessageCount: conversation?.Group?.UnreadMessageCount,
      lastExternalMessageDate: conversation?.Group?.LastExternalMessageDate,
      lastMessageDateTime: conversation?.Group?.LastMessageDateTime,
      messages: [],
      memberType: lastMessage?.MemberType,
      lastMessage: {
        text: lastMessage?.Content,
        type: lastMessage?.MessageType,
        status: lastMessage?.DeliveryStatus,
        reply:  lastMessage?.Reply || null,
        originalMessageContext: lastMessage?.OriginalMessageContext || null,
      },
      subscribed: subscribed,
      expired: this.isExpired(conversation?.Group?.LastExternalMessageDate),
    };
  }

  static toLastMessage(c: PusherConversation) {
    let flowList;
    if(c.LastMessage?.FlowResponse){
      flowList = c.LastMessage?.FlowResponse?.List[0];
      flowList.response = c.LastMessage?.FlowResponse?.List[0].Response;
    }
    return {
      organizationId: c.LastMessage.OrganizationId,
      groupId: c.LastMessage.GroupId,
      phoneNumber: c.LastMessage.PhoneNumber,
      memberType: c.LastMessage.MemberType,
      messageType: c.LastMessage.MessageType,
      whatsAppMessageId: c.LastMessage.WhatsAppMessageId,
      waGroupMemberId: c.LastMessage.WAGroupMemberId,
      content: c.LastMessage.Content,
      reply: c.LastMessage?.Reply || null,
      originalMessageContext: {
        blobFileLink: c?.LastMessage?.OriginalMessageContext?.BlobFileLink || null,
        contextMediaType: c?.LastMessage?.OriginalMessageContext?.ContextMediaType || null,
        text: c?.LastMessage?.OriginalMessageContext?.Text || null,
      },
      messageContextId: c.LastMessage?.MessageContextId || null,
      reaction: c.LastMessage?.Reaction || null,
      receiverName: c.LastMessage?.ReceiverName || null,
      contextType: c.LastMessage?.ContextType || null,
      payload: null,
      deliveryStatus: c.LastMessage.DeliveryStatus,
      deliveryMessage: c.LastMessage.DeliveryMessage,
      senderId: c.LastMessage.SenderId,
      senderName: c.LastMessage.SenderName,
      avatarColorCode: c.LastMessage.AvatarColorCode,
      id: c.LastMessage.Id,
      createdBy: c.LastMessage.CreatedBy,
      createdDate: c.LastMessage.CreatedDate,
      updatedDate: c.LastMessage.UpdatedDate,
      subscribed: c.Subscribed,
      flowResponse: flowList ? {
        list:[flowList],
      } : null,
    };
  }

  static isExpired(date: string): boolean {
    if (!date) return false;
    const pastDate = moment(date);
    const hoursDifference = moment().diff(pastDate, 'hours');
    return hoursDifference > 24;
  }
}

export interface PusherConversation {
  Group?: Group;
  InternalMember?: InternalMember;
  ExternalMember?: ExternalMember;
  LastMessage?: LastMessage;
  Subscribed?: boolean;
}

interface Group {
  DisplayName?: string;
  Name?: string;
  Type?: string;
  IsActive?: boolean;
  OrganizationId?: number;
  InternalPhoneNoId?: number;
  LastMessageId?: number;
  LastMessageDateTime?: string;
  UnreadMessageCount?: number;
  LastExternalMessageDate?: string;
  Id?: number;
  CreatedBy?: number;
  CreatedDate?: string;
  UpdatedDate?: string;
}

interface InternalMember {
  WAGroupId?: number;
  MemberType?: string;
  PhoneNumber?: string;
  DisplayName?: string;
  Id?: number;
  CreatedBy?: number;
  CreatedDate?: string;
  UpdatedDate?: string;
}

interface ExternalMember {
  WAGroupId?: number;
  MemberType?: string;
  PhoneNumber?: string;
  DisplayName?: string;
  AccountName?: any;
  AccountId?: any;
  ContactName?: any;
  ContactId?: any;
  Id?: number;
  CreatedBy?: number;
  CreatedDate?: string;
  UpdatedDate?: string;
}

interface LastMessage {
  OrganizationId?: number;
  GroupId?: number;
  PhoneNumber?: string;
  MemberType?: string;
  MessageType?: string;
  WhatsAppMessageId?: string;
  WAGroupMemberId?: number;
  Content?: string;
  Reply?: string;
  MessageContextId?: string;
  Reaction?: string;
  ReceiverName?: string;
  ContextType?: string;
  DeliveryStatus?: string;
  DeliveryMessage?: string;
  SenderId?: number;
  SenderName?: string;
  AvatarColorCode?: string;
  Id?: number;
  CreatedBy?: number;
  CreatedDate?: string;
  UpdatedDate?: string;
  OriginalMessageContext?: OriginalContext;
  FlowResponse?: any;
}

interface OriginalContext {
  BlobFileLink?: string,
  ContextMediaType?: string,
  Text?: string,
}
